function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  id: "defs2"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "layer1",
  transform: "translate(-93.225181,-186.46823)"
}, /*#__PURE__*/React.createElement("g", {
  id: "g844",
  transform: "matrix(0.52916667,0,0,0.52916667,87.3125,159.12798)"
}, /*#__PURE__*/React.createElement("g", {
  id: "g887"
}, /*#__PURE__*/React.createElement("path", {
  d: "m 12.17599,51.66661 c -0.40625,0 -0.769531,0.24609 -0.925781,0.62109 -0.152344,0.37891 -0.0625,0.8086 0.230469,1.09375 l 19.29297,19.29297 -19.29297,19.29297 c -0.261719,0.25 -0.367188,0.625 -0.273438,0.97266 0.08984,0.35156 0.363282,0.625 0.714844,0.71484 0.347656,0.0937 0.722656,-0.0117 0.972656,-0.27344 l 20.000001,-20 c 0.390625,-0.39062 0.390625,-1.02343 0,-1.41406 l -20.000001,-20 c -0.1875,-0.19531 -0.445312,-0.30078 -0.71875,-0.30078 z",
  id: "path859"
}), /*#__PURE__*/React.createElement("path", {
  d: "m 52.371306,51.66661 c 0.40625,0 0.769531,0.24609 0.925781,0.62109 0.152344,0.37891 0.0625,0.8086 -0.230469,1.09375 l -19.29297,19.29297 19.29297,19.29297 c 0.261719,0.25 0.367188,0.625 0.273438,0.97266 -0.08984,0.35156 -0.363282,0.625 -0.714844,0.71484 -0.347656,0.0937 -0.722656,-0.0117 -0.972656,-0.27344 l -20.000001,-20 c -0.390625,-0.39062 -0.390625,-1.02343 0,-1.41406 l 20.000001,-20 c 0.1875,-0.19531 0.445312,-0.30078 0.71875,-0.30078 z",
  id: "path883"
}))));

var SvgClose = function SvgClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22.330917mm",
    height: "22.236607mm",
    viewBox: "0 0 22.330917 22.236607",
    id: "svg8",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close.fc29f1ca.svg";
export { ForwardRef as ReactComponent };